import React, { PureComponent } from 'react'
import { get } from 'lodash-es'
import gql from 'graphql-tag'
import {Query} from 'react-apollo'
import { ApplicationLoader } from "./with-data"

const query = gql`
  query Texts($surveyId: UUID!, $languageCode: String) {
    translations(surveyId: $surveyId, languageCode: $languageCode)
  }
`

export function withTranslations(WrappedComponent) {
  return class extends PureComponent {
    useTranslate = (phrase, translations) => {
      if (get(translations, phrase)) {
        return get(translations, phrase)
      }
      console.warn('Missing translation for:', phrase)
      return phrase
    }

    render() {
      const { surveyId, languageCode = 'en' } = this.props.match.params

      return (
        <Query
          query={query}
          variables={{ surveyId, languageCode }}
          fetchPolicy="cache-first"
        >
          {({ data, loading, networkStatus, error, refetch }) => {
            if (error || (loading && networkStatus < 4)) {
              return <ApplicationLoader error={error} />;
            }

            return (
              <WrappedComponent
                useTranslate={(phrase) =>
                  this.useTranslate(phrase, data.translations)
                }
                {...this.props}
              />
            );
          }}
        </Query>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/decorators/with-translations.js